import { RequestMethods } from 'utils/axios/methods'
import { call, put } from 'redux-saga/effects'
import { Actions_PageLoader } from 'redux/modules/pageloader/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TStoreTemplate } from 'redux/config/root-types'
import { TFutureBooking } from 'redux/modules/bookings/TReducer'
import { Actions_Bookings } from 'redux/modules/bookings/Actions'

const { get } = RequestMethods()

export default function* SagaPage_Bookings() {
  try {
    yield put(Actions_PageLoader.store.showLoader())
    //------------------------- Getting and saving parent organizations ----------------------//

    const bookings: TStoreTemplate<TFutureBooking[]> = yield call(
      async () => await get<TFutureBooking[]>('/bookings/forFuture'),
    )

    yield put(Actions_Bookings.store.saveBookings(bookings))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_PageLoader.store.hideLoader())
  }
}
